import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { SimpleModalComponent } from "ngx-simple-modal";
import { Link, LinkModal } from "../links.model";
import { NmsWizardComponent, NmsWizardStepMapData } from "@nms-angular-toolkit/nms-wizard";
import { DeviceLinkModel } from "./steps/1-devices/link-device-model";
import { GeneralLinkModel } from "./steps/2-general/link-general-model";
import { LinkStepModelsUtilsService } from "../services/link-step-models-utils";
import { Subscription } from "rxjs";
import { LinkService } from "../services/link.service";

/**
 * Componente responsável por renderizar a modal para adicionar link.
 */
@Component({
    selector: "add-link-modal",
    templateUrl: "./add-link-modal.component.html",
    styleUrls: ["./add-link-modal.component.scss"]
})
export class AddLinkModalComponent extends SimpleModalComponent<LinkModal, any> implements OnInit, OnDestroy, LinkModal {

    @ViewChild(NmsWizardComponent)
    nmsWizard: NmsWizardComponent;
    linkInfo: Link;
    pageTitle: string = "add.link.modal.title";
    isLoading: boolean = false;
    wizardStepsCacheMap: NmsWizardStepMapData = {};
    deviceLinkModel: DeviceLinkModel;
    generalLinkModel: GeneralLinkModel;
    closeModalSubscription: Subscription;

    constructor(private readonly linkService: LinkService,
                private readonly linkStepModelsUtilsService: LinkStepModelsUtilsService) {
        super();
        this.closeModalSubscription = this.linkService.closeModalEmmiter.subscribe(() => this.close());
    }

    async ngOnInit(): Promise<void> {
        if (this.linkInfo) {
            this.isLoading = true;
            this.pageTitle = this.linkInfo.id ? "edit.link.modal.title" : this.pageTitle;
            await this.fillTabsData();
            this.isLoading = false;
        }
    }

    ngOnDestroy(): void {
        if (this.closeModalSubscription) {
            this.closeModalSubscription.unsubscribe();
        }
    }

    async fillTabsData(): Promise<void> {
        // NOSONAR
        this.deviceLinkModel = await this.linkStepModelsUtilsService.buildDeviceLinkModel(this.linkInfo);
        // NOSONAR
        this.generalLinkModel = await this.linkStepModelsUtilsService.buildGeneralLinkModel(this.linkInfo);
        this.wizardStepsCacheMap["DeviceLinkModel"] = this.deviceLinkModel;
        this.wizardStepsCacheMap["GeneralLinkModel"] = this.generalLinkModel;
    }

    cancel(): void {
        this.close();
    }

}
